import axios from "axios";
export default {
  namespaced: true,
  state: {
    equipment: [],
    equipment_check_today: { check: null, equipment: [] },
    equipment_checks: [],
    daily_check_today: { check: null, options: [] },
    daily_checks: [],
    daily_check_options: [],
    check_settings: { equipment_check_days: [] },
  },
  getters: {
    equipment(state) {
      return state.equipment;
    },
    equipment_check_today(state) {
      return state.equipment_check_today;
    },
    equipment_checks(state) {
      return state.equipment_checks;
    },
    daily_check_today(state) {
      return state.daily_check_today;
    },
    daily_checks(state) {
      return state.daily_checks;
    },
    daily_check_options(state) {
      return state.daily_check_options;
    },
    check_settings(state) {
      return state.check_settings;
    },
  },
  mutations: {
    SET_EQUIPMENT(state, equipment) {
      state.equipment = equipment;
    },
    ADD_EQUIPMENT(state, equipment) {
      state.equipment.unshift(equipment);
    },
    EDIT_EQUIPMENT(state, equipment) {
      var index = state.equipment.findIndex((a) => a.id == equipment.id);
      state.equipment.splice(index, 1, equipment);
    },
    RETIRE_EQUIPMENT(state, id) {
      var index = state.equipment.findIndex((a) => a.id == id);
      if (index !== -1) {
        state.equipment.splice(index, 1, {
          ...state.equipment[index],
          is_active: false,
        });
      }
    },
    SET_EQUIPMENT_CHECK_TODAY(state, data) {
      state.equipment_check_today = data;
    },
    SET_EQUIPMENT_CHECKS(state, checks) {
      state.equipment_checks = checks;
    },
    SET_DAILY_CHECK_TODAY(state, check) {
      state.daily_check_today = check;
    },
    SET_DAILY_CHECKS(state, checks) {
      state.daily_checks = checks;
    },
    SET_DAILY_CHECK_OPTIONS(state, options) {
      state.daily_check_options = options;
    },
    ADD_DAILY_CHECK_OPTION(state, option) {
      state.daily_check_options.push(option);
    },
    EDIT_DAILY_CHECK_OPTION(state, option) {
      var index = state.daily_check_options.findIndex((a) => a.id == option.id);
      if (index !== -1) state.daily_check_options.splice(index, 1, option);
    },
    SET_CHECK_SETTINGS(state, settings) {
      state.check_settings = settings;
    },
  },
  actions: {
    async get_equipment({ commit }) {
      let response = await axios.get("/facility_equipment", {
        params: { include_inactive: 1 },
      });
      commit("SET_EQUIPMENT", response.data);
    },
    async add_equipment({ commit }, request) {
      let response = await axios.post("/facility_equipment", request);
      commit("ADD_EQUIPMENT", response.data);
    },
    async edit_equipment({ commit }, request) {
      let response = await axios.put("/facility_equipment", request);
      commit("EDIT_EQUIPMENT", response.data);
    },
    async retire_equipment({ commit }, id) {
      await axios.delete("/facility_equipment/" + id);
      commit("RETIRE_EQUIPMENT", id);
    },
    async get_equipment_check_today({ commit }) {
      let response = await axios.get("/facility_equipment_checks/today");
      commit("SET_EQUIPMENT_CHECK_TODAY", response.data);
    },
    async submit_equipment_check(_, request) {
      let response = await axios.post("/facility_equipment_check", request);
      return response.data;
    },
    async update_equipment_check(_, { id, ...request }) {
      let response = await axios.put(
        "/facility_equipment_check/" + id,
        request
      );
      return response.data;
    },
    async get_equipment_checks({ commit }, filters) {
      let params = {};
      if (filters.from_date) params.from_date = filters.from_date;
      if (filters.to_date) params.to_date = filters.to_date;
      if (filters.branch_id) params.branch_id = filters.branch_id;
      let response = await axios.get("/facility_equipment_checks", { params });
      commit("SET_EQUIPMENT_CHECKS", response.data);
    },
    async get_equipment_check(_, id) {
      let response = await axios.get("/facility_equipment_check/" + id);
      return response.data;
    },
    async get_daily_check_today({ commit }) {
      let response = await axios.get("/facility_daily_checks/today");
      commit("SET_DAILY_CHECK_TODAY", response.data);
    },
    async submit_daily_check(_, request) {
      let response = await axios.post("/facility_daily_check", request);
      return response.data;
    },
    async update_daily_check(_, { id, ...request }) {
      let response = await axios.put("/facility_daily_check/" + id, request);
      return response.data;
    },
    async get_daily_checks({ commit }, filters) {
      let params = {};
      if (filters.from_date) params.from_date = filters.from_date;
      if (filters.to_date) params.to_date = filters.to_date;
      if (filters.branch_id) params.branch_id = filters.branch_id;
      let response = await axios.get("/facility_daily_checks", { params });
      commit("SET_DAILY_CHECKS", response.data);
    },
    async get_daily_check(_, id) {
      let response = await axios.get("/facility_daily_check/" + id);
      return response.data;
    },
    async get_daily_check_options({ commit }, params = {}) {
      let response = await axios.get("/facility_daily_check_options", {
        params,
      });
      commit("SET_DAILY_CHECK_OPTIONS", response.data);
      return response.data;
    },
    async add_daily_check_option({ commit }, request) {
      let response = await axios.post("/facility_daily_check_options", request);
      commit("ADD_DAILY_CHECK_OPTION", response.data);
      return response.data;
    },
    async edit_daily_check_option({ commit }, request) {
      let response = await axios.put("/facility_daily_check_options", request);
      commit("EDIT_DAILY_CHECK_OPTION", response.data);
      return response.data;
    },
    async retire_daily_check_option({ commit }, id) {
      let response = await axios.delete("/facility_daily_check_options/" + id);
      commit("EDIT_DAILY_CHECK_OPTION", response.data);
      return response.data;
    },
    async get_facility_check_settings({ commit }) {
      let response = await axios.get("/facility_check_settings");
      commit("SET_CHECK_SETTINGS", response.data);
      return response.data;
    },
    async update_facility_check_settings({ commit }, request) {
      let response = await axios.put("/facility_check_settings", request);
      commit("SET_CHECK_SETTINGS", response.data);
      return response.data;
    },
  },
};
